<template>
    <div ref="wrapper">
        <slot></slot>
        <div ref="pulldown" class="pulldown-wrapper" :style="pullDownStyle" v-if="pulldown">
            <div class="before-trigger" v-if="pulldown">
                <bubble :y="bubbleY"></bubble>
            </div>
            <!-- <div class="after-trigger" v-else>
          <div v-if="isPullingDown" class="loading">
            <loading></loading>
          </div>
          <div v-else><span>{{refreshTxt}}</span></div>
        </div> -->
        </div>
    </div>
</template>
<script>
import BScroll from 'better-scroll'
import Bubble from '../bubble/bubble.vue'
export default {
    props: {
        probeType: {
            type: Number,
            default: 1
        },
        momentum: {
            type: Boolean,
            default: true
        },
        scrollX: {
            type: Boolean,
            default: false
        },
        scrollY: {
            type: Boolean,
            default: true
        },
        click: {
            type: Boolean,
            default: true
        },
        data: {
            type: Array,
            default: null
        },
        listenScroll: {
            type: Boolean,
            default: false
        },
        bounce: {
            type: Boolean,
            default: true
        },
        pullup: {
            type: Boolean,
            default: false
        },
        pulldown: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Bubble
    },
    mounted() {
        setTimeout(() => {
            this._initScroll()
        }, 20)
    },
    watch: {
        data() {
            setTimeout(() => {
                this.refresh()
            }, 20)
        }
    },
    data() {
        return {
            bubbleY: 0,
            pullDownStyle: '',
            pullDownRefresh: true
        }
    },
    methods: {
        _initScroll() {
            if (!this.$refs.wrapper) {
                return
            }
            this.scroll = new BScroll(this.$refs.wrapper, {
                probeType: this.probeType,
                scrollX: this.scrollX,
                scrollY: this.scrollY,
                bounce: this.bounce,
                click: this.click,
                momentum: this.momentum
            })

            if (this.listenScroll) {
                this.scroll.on('scroll', (pos) => {
                    this.$emit('scroll', pos)
                })
            }
            // 是否派发滚动到底部事件，用于上拉加载
            if (this.pullup) {
                this.scroll.on('scrollEnd', () => {
                    // 滚动到底部
                    if (this.scroll.y <= (this.scroll.maxScrollY + 50)) {
                        this.$emit('scrollToEnd')
                    }
                })
            }
            // 是否派发顶部下拉事件，用于下拉刷新
            if (this.pulldown) {
                this.scroll.on('scroll', (pos) => {
                    this.$emit('scroll', pos)
                })
                this.scroll.on('touchEnd', (pos) => {
                    // 下拉动作
                    if (pos.y > 70) {
                        this.$emit('scrollToTop', pos)
                    }
                })
            }
        },
        enable() {
            this.scroll && this.scroll.enable()
        },
        disable() {
            this.scroll && this.scroll.disable()
        },
        refresh() {
            this.scroll && this.scroll.refresh()
        },
        scrollTo() {
            this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments)
        },
        scrollToElement() {
            this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
        }
    }
}
</script>
<style scoped lang="scss">
.pulldown-wrapper {
    position: absolute;
    width: 100%;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all;
    z-index: 1;
    .after-trigger {
        margin-top: 10px;
    }
}


.pullup-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 0;
}
</style>